<template>
    <div class="note-textarea__wrapper">
        <label class="base-label" v-if="label">{{label}}</label>
        <textarea class="note-textarea"
            v-bind="{
                    ...$attrs,
                    onkeydown:(event)=>{
                       $emit('update:modelValue',maxLength > 0 ? event.target.value.substring(0,maxLength):event.target.value )
                    },
                    onInput: (event)=>{

                            $emit('update:modelValue',maxLength > 0 ? event.target.value.substring(0,maxLength):event.target.value)


                       }
                    }"

            :value="maxLength > 0 ? modelValue.substring(0, maxLength -1) : modelValue"
            :placeholder="placeholder"
        />
      <span class="length-counter" v-if="maxLength > 0">{{modelValue.length}}/{{maxLength}}</span>
    </div>
</template>

<script>
    export default {
        name: "BaseTextArea",
        props: {
            modelValue: {
                type:[String, Number],
                default: ''

            },
            label: {
                type: String,
                default: null
            },
            placeholder: {
                type: String,
                default: ''
            },
            emptyImage: {
                type: String,
                default: ''
            },
            maxLength: {
              type: Number,
              default: -1
          },
        },

    }
</script>

<style scoped>
.length-counter{
  font-size:12px;
  float:right;
}
</style>
